"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketEvidenceLink = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const service_ticket_entity_1 = require("./service-ticket.entity");
let TicketEvidenceLink = class TicketEvidenceLink {
};
exports.TicketEvidenceLink = TicketEvidenceLink;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], TicketEvidenceLink.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => service_ticket_entity_1.ServiceTicket, { onDelete: 'CASCADE' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof service_ticket_entity_1.ServiceTicket !== "undefined" && service_ticket_entity_1.ServiceTicket) === "function" ? _a : Object)
], TicketEvidenceLink.prototype, "ticket", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'ticketId' }),
    tslib_1.__metadata("design:type", Number)
], TicketEvidenceLink.prototype, "ticketId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Index)({ unique: true }),
    (0, typeorm_1.Column)({ length: 64 }),
    tslib_1.__metadata("design:type", String)
], TicketEvidenceLink.prototype, "token", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], TicketEvidenceLink.prototype, "expiresAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'json', nullable: true }),
    tslib_1.__metadata("design:type", Array)
], TicketEvidenceLink.prototype, "files", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], TicketEvidenceLink.prototype, "uploadComplete", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], TicketEvidenceLink.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], TicketEvidenceLink.prototype, "updatedAt", void 0);
exports.TicketEvidenceLink = TicketEvidenceLink = tslib_1.__decorate([
    (0, typeorm_1.Entity)('ticket_evidence_links')
], TicketEvidenceLink);
